import React from "react";
import { useTranslation } from "react-i18next";

const ScheduleIntro = () => {
  const { t } = useTranslation();
  return (
    <div className="full-wrap conta">
      <div className="paragraph-wrap _65">
        <div className="pad-15">
          <h3 className="heading-38">{t("schedule.heading")}</h3>
        </div>
        <p className="body-16">{t("schedule.description")}</p>
      </div>
    </div>
  );
};

export default ScheduleIntro;
